// extracted by mini-css-extract-plugin
export var container = "qualities-gallery-module--container--UnZd6";
export var item = "qualities-gallery-module--item--9jxJW";
export var list = "qualities-gallery-module--list--kFjv7";
export var slider = "qualities-gallery-module--slider--0vvjB";
export var sliderItem = "qualities-gallery-module--slider-item--DXUv-";
export var title = "qualities-gallery-module--title--Hlecw";